module.exports = __webpack_public_path__ + "static/media/cart-plus.227ab6e0.svg";